<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6"><template v-if="brand.copyright">{{ new Date().getFullYear() }} © {{ brand.copyright }}</template></div>
        <div class="col-sm-6">
          <div class="text-sm-end d-none d-sm-block"></div>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>

<script>
import { brand } from "@/helpers/brand";

export default {
  data() {
    return { brand };
  },
};
</script>
